import { PatientTestsDropdownRootContainer } from './patient-tests-dropdown-root-container';

export default PatientTestsDropdownRootContainer;
